enum InventorySubType {
  WEB_DASHBOARD = "WEB_DASHBOARD",
  WEB_PROFILE_FORM = "WEB_PROFILE_FORM",
  MOBILE_DASHBOARD = "MOBILE_DASHBOARD",
  REGISTRATION = "REGISTRATION"
}

export default InventorySubType;
